module.exports = __webpack_public_path__ + "img/visa_mastercard_logo.56995b9e.png";